// extracted by mini-css-extract-plugin
export var completionBody = "_i7-2";
export var completionCard = "_i7-0";
export var completionFooter = "_i7-3";
export var completionTitle = "_i7-1";